import { ClipLoader } from "react-spinners";
import { LoadingStatus } from "../../../common/commonSlice";
import { RoleProfile, UserData } from "../../configurationAPI";
import { formatDateStandar } from "../../../../helpers/utils";
import { BackofficeAsesor } from "../../../services/analytics/analyticsAPI";

export interface AccountViewProps {
  accountData: UserData | null;
  width: string;
  loading: LoadingStatus;
  roleProfile?: RoleProfile;
  asesorInfo?: BackofficeAsesor;
  ownUser?: boolean;
  changeInfoFunction?: Function;
  changeHistoryFunction?: Function;
}

export const AccountView = (props: AccountViewProps) => {
  const getAsesorInfo = () => {
    if (props.asesorInfo && props.asesorInfo.asesorData) {
      const asesorFields: JSX.Element[] = [];
      if (
        props.asesorInfo.asesorData &&
        props.asesorInfo.asesorData.fieldsToShow
      ) {
        props.asesorInfo.asesorData.fieldsToShow.forEach((field) => {
          if (field.type !== "HIDDEN") {
            asesorFields.push(
              <h6
                style={{
                  fontSize: "13px",
                  fontWeight: 500,
                  color: "white",
                }}
              >
                {field.label}:<br /> <strong>{field.value}</strong>
              </h6>
            );
          }
        });
      }
      return (
        <a
          href={`https://forms.anteia.co/asesores?idAsesor=${props.asesorInfo.id}`}
          target="_blank"
        >
          <div
            className="flex-col text-medium primary-color"
            style={{
              cursor: "pointer",
              background: "rgba(0,0,0,0.1)",
              width: "100%",
              borderRadius: "16px",
              padding: "2% 0 10px 2%",
            }}
          >
            <h5
              style={{
                fontSize: "16px",
                fontWeight: 700,
                color: "white",
                textAlign: "center",
              }}
            >
              Información de Asesor <br />
              <span
                style={{
                  fontSize: "10px",
                  fontWeight: 500,
                  color: "rgba(255,255,255,0.8)",
                }}
              >
                (Click para visitar tarjeta de asesor)
              </span>
            </h5>
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "1fr 1fr",
                gridRowGap: "5px",
                columnGap: "10px",
                width: "100%",
                margin: "8px 0px 0px 0px",
              }}
            >
              {props.asesorInfo.asesorData.oficina && (
                <h6
                  style={{
                    fontSize: "13px",
                    fontWeight: 500,
                    color: "white",
                  }}
                >
                  Oficina: <br />
                  <strong>{props.asesorInfo.asesorData.oficina}</strong>
                </h6>
              )}
              {props.asesorInfo.asesorData.cargo && (
                <h6
                  style={{
                    fontSize: "13px",
                    fontWeight: 500,
                    color: "white",
                  }}
                >
                  Cargo: <br />
                  <strong>{props.asesorInfo.asesorData.cargo}</strong>
                </h6>
              )}
              {props.asesorInfo.asesorData.direccion && (
                <h6
                  style={{
                    fontSize: "13px",
                    fontWeight: 500,
                    color: "white",
                  }}
                >
                  Dirección: <br />{" "}
                  <strong>{props.asesorInfo.asesorData.direccion}</strong>
                </h6>
              )}
              {asesorFields}
            </div>
          </div>
        </a>
      );
    } else {
      return <></>;
    }
  };

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "start",
        width: props.width,
      }}
    >
      <div
        style={{
          width: "100%",
          padding: "8px 0px 8px 0px",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          textAlign: "center",
          fontSize: "15px",
          backgroundColor: "rgba(0,0,0,0.4)",
          color: "rgba(255,255,255, 0.8)",
          borderRadius: "8px 8px 0px 0px",
          fontWeight: "600",
        }}
      >
        Información del usuario
      </div>
      <div
        style={{
          width: "100%",
          padding: "8px 12px 8px 12px",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "start",
          backgroundColor: "rgba(0,0,0,0.2)",
          borderRadius: "0px 0px 8px 8px",
        }}
      >
        {props.loading === "pending" ? (
          <ClipLoader color="#FFF" size="120px" />
        ) : (
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              width: "100%",
              justifyContent: "start",
            }}
          >
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "1fr 1fr",
                gridRowGap: "5px",
                columnGap: "10px",
                width: "100%",
                margin: "5px 0px 5px 10px",
              }}
            >
              {props.accountData?.name && (
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                  }}
                >
                  <p
                    style={{
                      fontSize: "12px",
                      color: "#FFF",
                      fontWeight: "500",
                      textAlign: "start",
                      margin: "0 0 2px 0",
                    }}
                  >
                    Nombre
                  </p>
                  <h6
                    style={{
                      fontSize: "15px",
                      fontWeight: "600",
                      textAlign: "start",
                      color: "#FFF",
                    }}
                  >
                    {props.accountData.name}
                  </h6>
                </div>
              )}
              {props.accountData?.email && (
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                  }}
                >
                  <p
                    style={{
                      fontSize: "12px",
                      color: "#FFF",
                      fontWeight: "500",
                      textAlign: "start",
                      margin: "0 0 2px 0",
                    }}
                  >
                    Correo electrónico
                  </p>
                  <h6
                    style={{
                      fontSize: "15px",
                      fontWeight: "600",
                      textAlign: "start",
                      color: "#FFF",
                    }}
                  >
                    {props.accountData.email}
                  </h6>
                </div>
              )}
              {props.accountData?.identification && (
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                  }}
                >
                  <p
                    style={{
                      fontSize: "12px",
                      color: "#FFF",
                      fontWeight: "500",
                      textAlign: "start",
                      margin: "0 0 2px 0",
                    }}
                  >
                    Número de identificación
                  </p>
                  <h6
                    style={{
                      fontSize: "15px",
                      fontWeight: "600",
                      textAlign: "start",
                      color: "#FFF",
                    }}
                  >
                    {props.accountData.identification}
                  </h6>
                </div>
              )}
              {props.accountData?.phoneNumber && (
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                  }}
                >
                  <p
                    style={{
                      fontSize: "12px",
                      color: "#FFF",
                      fontWeight: "500",
                      textAlign: "start",
                      margin: "0 0 2px 0",
                    }}
                  >
                    Número de teléfono
                  </p>
                  <h6
                    style={{
                      fontSize: "15px",
                      fontWeight: "600",
                      textAlign: "start",
                      color: "#FFF",
                    }}
                  >
                    {props.accountData.phoneNumber}
                  </h6>
                </div>
              )}{" "}
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <p
                  style={{
                    fontSize: "12px",
                    color: "#FFF",
                    fontWeight: "500",
                    textAlign: "start",
                    margin: "0 0 2px 0",
                  }}
                >
                  Estado de la cuenta
                </p>
                <h6
                  style={{
                    fontSize: "15px",
                    fontWeight: "600",
                    textAlign: "start",
                    color: "#FFF",
                  }}
                >
                  {props.accountData?.active ? "Activo" : "Inactivo"}
                </h6>
              </div>
              {props.accountData?.userId && (
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                  }}
                >
                  <p
                    style={{
                      fontSize: "12px",
                      color: "#FFF",
                      fontWeight: "500",
                      textAlign: "start",
                      margin: "0 0 2px 0",
                    }}
                  >
                    Identidad digital (click para visitar)
                  </p>
                  <h6
                    style={{
                      fontSize: "15px",
                      fontWeight: "600",
                      textAlign: "start",
                      color: "#FFF",
                    }}
                  >
                    <a
                      href={`/services/coreId/registrations${props.accountData.userId}`}
                      target="_blank"
                    >
                      {props.accountData.userId}
                    </a>
                  </h6>
                </div>
              )}
              {props.roleProfile && (
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                  }}
                >
                  <p
                    style={{
                      fontSize: "12px",
                      color: "#FFF",
                      fontWeight: "500",
                      textAlign: "start",
                      margin: "0 0 2px 0",
                    }}
                  >
                    Rol de permisos
                  </p>
                  <h6
                    style={{
                      fontSize: "15px",
                      fontWeight: "600",
                      textAlign: "start",
                      color: "#FFF",
                    }}
                  >
                    {props.roleProfile.name}
                  </h6>
                </div>
              )}
              {props.accountData?.creationDate && (
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                  }}
                >
                  <p
                    style={{
                      fontSize: "12px",
                      color: "#FFF",
                      fontWeight: "500",
                      textAlign: "start",
                      margin: "0 0 2px 0",
                    }}
                  >
                    Fecha de creación
                  </p>
                  <h6
                    style={{
                      fontSize: "15px",
                      fontWeight: "600",
                      textAlign: "start",
                      color: "#FFF",
                    }}
                  >
                    {formatDateStandar(props.accountData.creationDate)}
                  </h6>
                </div>
              )}
              {props.accountData?.lastUpdateDate && (
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                  }}
                >
                  <p
                    style={{
                      fontSize: "12px",
                      color: "#FFF",
                      fontWeight: "500",
                      textAlign: "start",
                      margin: "0 0 2px 0",
                    }}
                  >
                    Fecha de última actualización
                  </p>
                  <h6
                    style={{
                      fontSize: "15px",
                      fontWeight: "600",
                      textAlign: "start",
                      color: "#FFF",
                    }}
                  >
                    {formatDateStandar(props.accountData.lastUpdateDate)}
                  </h6>
                </div>
              )}
              {props.accountData?.latestLogin && (
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                  }}
                >
                  <p
                    style={{
                      fontSize: "12px",
                      color: "#FFF",
                      fontWeight: "500",
                      textAlign: "start",
                      margin: "0 0 2px 0",
                    }}
                  >
                    Fecha último inicio de sesión
                  </p>
                  <h6
                    style={{
                      fontSize: "15px",
                      fontWeight: "600",
                      textAlign: "start",
                      color: "#FFF",
                    }}
                  >
                    {formatDateStandar(props.accountData.latestLogin)}
                  </h6>
                </div>
              )}
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <p
                  style={{
                    fontSize: "12px",
                    color: "#FFF",
                    fontWeight: "500",
                    textAlign: "start",
                    margin: "0 0 2px 0",
                  }}
                >
                  Es asesor
                </p>
                <h6
                  style={{
                    fontSize: "15px",
                    fontWeight: "600",
                    textAlign: "start",
                    color: "#FFF",
                  }}
                >
                  {props.accountData?.esAsesor ? "Si" : "No"}
                </h6>
              </div>
            </div>
            {getAsesorInfo()}
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: props.ownUser ? "end" : "space-between",
                marginTop: "14px",
              }}
            >
              {!props.ownUser && (
                <button
                  onClick={(e) => {
                    e.preventDefault();
                    if (props.changeHistoryFunction) {
                      props.changeHistoryFunction();
                    }
                  }}
                  style={{
                    padding: "5px 10px",
                    textAlign: "center",
                    color: "#FFF",
                    background: "rgba(0,0,0,0.2)",
                    borderRadius: "8px",
                    border: "none",
                    maxWidth: "150px",
                    fontWeight: "600",
                    fontSize: "15px",
                  }}
                >
                  Ver historial de cambios
                </button>
              )}
              <button
                onClick={(e) => {
                  e.preventDefault();
                  if (props.changeInfoFunction) {
                    props.changeInfoFunction();
                  }
                }}
                style={{
                  padding: "5px 10px",
                  textAlign: "center",
                  color: "#FFF",
                  background: "rgba(0,0,0,0.2)",
                  borderRadius: "8px",
                  border: "none",
                  maxWidth: "150px",
                  fontWeight: "600",
                  fontSize: "15px",
                }}
              >
                Modificar información
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};
